import type { TFunction } from 'react-i18next';

import { dateToDoubleDecker } from '@/utils/dateUtils';
import { formatPhone, toFullName } from '@/utils/stringUtils';

import type { TMemberDetails, TMemberListItem } from '@/types/member';

const extractRoles = (member: TMemberListItem, t: TFunction) =>
  [member.admin && t('members.roles.admin'), member.member && t('members.roles.member')]
    .filter(Boolean)
    .join(', ');

const extractStations = (member: TMemberListItem) => [
  ...(member.admin ? member.adminAt : []),
  ...(member.member ? member.memberAt : []),
];

export const extractMemberVM = (member: TMemberListItem, t: TFunction) => ({
  id: member.userId,
  entity: member,
  name: toFullName(member),
  phone: formatPhone(member.phone),
  lastActive: dateToDoubleDecker(member.lastActive),
  stations: extractStations(member),
  role: extractRoles(member, t),
  status: {
    value: member.status,
    since: new Date(member.statusChangedOn),
  },
});

export const extractTable = (values: any) => {
  const adminAtValues = values.adminAt;
  const memberAtValues = values.memberAt;

  if (values.admin) {
    adminAtValues.forEach((element: TMemberDetails) => {
      // eslint-disable-next-line no-param-reassign
      element.admin = true;
    });
  }
  if (values.member) {
    memberAtValues.forEach((element: TMemberDetails) => {
      // eslint-disable-next-line no-param-reassign
      element.member = true;
    });
  }

  const tableData = [...adminAtValues, ...memberAtValues];
  return tableData;
};
